module.exports = __webpack_public_path__ + "static/media/logo-emgea.d6528b96.svg";